import { useState } from "react";
import { Button, Spin, Form, Input, Typography, Result, theme } from "antd";
import { LockOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import MD5 from "crypto-js/md5";
import authService from "../services/auth.service";
import { useNavigate } from "react-router-dom";

const { Text, Title } = Typography;

enum Status {
    Initial = "initial",
    Loading = "loading",
    Error = "error",
}

const Login = () => {
    const [status, setStatus] = useState(Status.Initial);
    const [errorMessage, setErrorMessage] = useState("");
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { token } = theme.useToken();

    const handleBackToLogin = () => setStatus(Status.Initial);

    const handleFormSubmit = async (values: any) => {
        setStatus(Status.Loading);
        try {
            await authService.login(MD5(values.password).toString());
            navigate("/board/balance");
            window.location.reload();
        } catch (error: any) {
            setStatus(Status.Error);
            setErrorMessage(error.message);
        }
    };

    const renderForm = () => (
        <Spin spinning={status === Status.Loading}>
            <Title style={{ fontSize: token.fontSizeHeading2, display: "inline" }}>
                С<p style={{ fontSize: token.fontSizeHeading2, color: "#ba80e6", display: "inline" }}>B</p>
            </Title>
            <Text style={{ color: token.colorTextSecondary, display: "block" }}>
                {t("Login.welcome")}
            </Text>
            <Form
                name="normal_login"
                initialValues={{ remember: true }}
                onFinish={handleFormSubmit}
                layout="vertical"
                requiredMark="optional"
            >
                <Form.Item
                    name="password"
                    rules={[{ required: true, message: t("Login.error.emptyPassword") }]}
                >
                    <Input.Password
                        prefix={<LockOutlined />}
                        type="password"
                        placeholder={t("placeholder.password")}
                    />
                </Form.Item>
                <Form.Item style={{ marginBottom: "0px" }}>
                    <Button block type="primary" htmlType="submit">
                        {t("button.enter")}
                    </Button>
                </Form.Item>
            </Form>
        </Spin>
    );

    switch (status) {
        case Status.Error:
            return (
                <Result
                    status="error"
                    title={t("Login.error.default")}
                    subTitle={errorMessage}
                    extra={
                        <Button type="primary" key="console" onClick={handleBackToLogin}>
                            {t("button.back")}
                        </Button>
                    }
                />
            );
        default:
            return (
                <section style={{ alignItems: "center", display: "flex", height: "100vh" }}>
                    <div style={{ margin: "0 auto", width: "380px" }}>{renderForm()}</div>
                </section>
            );
    }
};

export default Login;